import "./editor"
import "./display"
import "./add-schedule-to-regime"
import { ScheduleItemRight } from "slot-definitions"
import { ScheduleStatus } from "routes/regime/schedule-code"
import { isInRegime } from "routes/facilities/lib/when-parent-item"
import { and } from "lib/logic"

ScheduleItemRight.plug(<ScheduleStatus if={and(isInRegime, (c) => !c.facility)} priority={150} />)
